<div class="card-body">
  <div *ngIf="!message && !documentUrl">
    <div class="input-group-sm input-group h-2">
      <div class="input-group-prepend">
        <span class="input-group-text">Time </span>
      </div>
      <input
        placeholder="Time in hours"
        type="number"
        (change)="checkValidity()"
        [(ngModel)]="timeInHours"
        class="form-control"
      />
    </div>
  </div>

  <div *ngIf="message">
    {{ message }}
  </div>

  <div *ngIf="documentUrl" class="row">
    <div class="col-11" style="padding-left: 0;">
      <textarea #documentLinkText class="form-control" [ngModel]="documentUrl" style="height: 230px;" readonly></textarea>
    </div>
    <div class="col-1" style="padding: 0;">
      <button mat-stroked-button (click)="copyToClipboard(documentLinkText)"><mat-icon>content_copy</mat-icon></button>
    </div>
  </div>
</div>
<div class="float-right">
  <button
    *ngIf="!message && !documentUrl"
    mat-raised-button
    class="actionButton mr-2"
    (click)="generateLinkHandler()"
  >
    Generate Link
  </button>

  <button mat-raised-button class="closeButton" (click)="onCancel()">
    Back
  </button>
</div>
